"use client";

import dynamic from "next/dynamic";
import LoginPageView from "page-sections/sessions/page-view/login";

const LoginClientOnly = dynamic(
  () => Promise.resolve(LoginPageView),
  { ssr: false }
);

export default function Login() {
  return <LoginClientOnly />;
}
